import React from "react";
import DownArrow from "../../../styles/img/down-arrow.png";
import Select, { components } from "react-select";

export default function UiYearSelect(props) {
    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <img src={DownArrow} />
            </components.DropdownIndicator>
        );
    };
    const colorStyles = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#B1B5C3",
            };
        },
        menuPortal: provided => ({ ...provided, zIndex: 9999 }),
        menu: provided => ({ ...provided, zIndex: 9999 })
        
    };
    return (
       <>
                        {props.label &&
                            <label htmlFor={props.label}>{props.label}</label>
                        }
                            <Select 
                               
                               onChange={(selectedOption) => {
                                props.onChange?.(
                                    selectedOption?.value ?? null,
                                );
                                 }}
                                className="year-select-dropdown"
                                classNamePrefix="select"
                                // components={{ DropdownIndicator }}
                                styles={colorStyles}
                                placeholder={props.placeholder}
                                options={props.options}
                                menuPosition={'fixed'}
                            />

                        
                    </>
       
    );
}

